import { modalRenderer } from '~/modal/modalRendererRegistry';
import { UpgradeWMSSubscriptionModalComponent } from './upgradeWMSSubscriptionModal.component';

declare module '~/modal/modalRegistry.type' {
  interface ModalComponentRegistry {
    WMSUpgradeSubscription: undefined;
  }
}

modalRenderer.register('WMSUpgradeSubscription', UpgradeWMSSubscriptionModalComponent);
